import styled from 'styled-components';

export const BookListWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  margin-bottom: 34px;
`;
